import { FC, useEffect } from 'react';
import { Form, Modal, Radio, Wrapper, NavigationPreference, Button, SubContent, FormTitle } from '@maxtropy/components';
import {
  getCurrentUser,
  updateCustomerUserNavigationPreference,
  UpdateCustomerUserNavigationPreferenceRequest,
} from '../../api/user';
import styles from './index.module.scss';
import dayjs from 'dayjs';

const routes = [{ name: '个人中心' }, { name: '个人设置' }, { name: '个人偏好' }];

const NavigationPreferenceDisplay: Record<NavigationPreference, string> = {
  [NavigationPreference.AUTO]: '支持收起/展示',
  [NavigationPreference.OPEN]: '一直展开',
  [NavigationPreference.HIDE]: '直接隐藏',
};

const NavigationPreferencePage: FC = () => {
  const [form] = Form.useForm<UpdateCustomerUserNavigationPreferenceRequest>();

  const onFinish = (values: UpdateCustomerUserNavigationPreferenceRequest) => {
    updateCustomerUserNavigationPreference(values).then(() => {
      // 微前端下需要通知主项目更新layout
      window.microApp?.dispatch({ update: dayjs().valueOf() });
      // 非微前端需要更新layout
      Modal.success({
        title: '保存成功',
      });
    });
  };

  useEffect(() => {
    getCurrentUser().then(res => {
      console.log(res.customerUser.navigationPreference);
      form.setFieldsValue({
        navigationPreference: res.customerUser.navigationPreference ?? NavigationPreference.AUTO,
      });
    });
  }, [form]);

  return (
    <Wrapper routes={routes} className={styles.wrapperPadding}>
      <FormTitle title="个人偏好" />
      <Form form={form} onFinish={onFinish} style={{ width: '100%' }}>
        <SubContent>
          <Form.Item label="左侧导航栏" name="navigationPreference" required>
            <Radio.Group>
              <Radio value={NavigationPreference.AUTO}>{NavigationPreferenceDisplay[NavigationPreference.AUTO]}</Radio>
              <Radio value={NavigationPreference.OPEN}>{NavigationPreferenceDisplay[NavigationPreference.OPEN]}</Radio>
              <Radio value={NavigationPreference.HIDE}>{NavigationPreferenceDisplay[NavigationPreference.HIDE]}</Radio>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" htmlType="submit" wrapStyle={{ marginTop: 8 }}>
            保存
          </Button>
        </SubContent>
      </Form>
    </Wrapper>
  );
};

export default NavigationPreferencePage;
